module.exports = __webpack_public_path__ + "img/158-Skai Mattex Fenstergrau.jpg";